// exportUtilsOld.js
const ExcelJS = require('exceljs');


export const handleExportClickOld = async (namaSpv, jabatanSpv, namaLengkapUser, pinjaman, cabang, tanggal) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");
  workbook.styles = {
    ...workbook.styles,
    baseFont: { name: 'Calibri', size: 12 }
  };

  function toRoman(number) {
    const romanNumeralMap = {
        M: 1000,
        CM: 900,
        D: 500,
        CD: 400,
        C: 100,
        XC: 90,
        L: 50,
        XL: 40,
        X: 10,
        IX: 9,
        V: 5,
        IV: 4,
        I: 1
    };
    let result = '';

    for (let key in romanNumeralMap) {
        while (number >= romanNumeralMap[key]) {
            result += key;
            number -= romanNumeralMap[key];
        }
    }

    return result;
}
  
  function currencyFormat(amount) {
    return `Rp. ${new Intl.NumberFormat('id-ID').format(amount)}`;
  }
  // Tambahkan konten tabel ke worksheet
  worksheet.columns = [
    { header: "", key: "header1" },
    { header: "MEMO ANALISA SLIK DAN PENGECEKAN KTP", key: "header2"},
    // Tambahkan kolom lain sesuai kebutuhan
  ];
  worksheet.getCell('B2').value = 'MEMO INTERN & DATA KTP';

//=================> BIODATA <======================
// const jumlahDataPinjamanArray = iB > 0 ? pinjaman[iB-1].pinjaman.length : 0;
let lastBiodata = 0;
 if (pinjaman && pinjaman.length > 0) {
    let totalRowAkhirPinjaman = 0;

    for (let iB = 0; iB < pinjaman.length; iB++) {
      lastBiodata = iB;
      let totalLength = 0; 
      for (let iL = 0; iL <= iB; iL++) {
        totalLength += iL > 0 ? pinjaman[iL-1].pinjaman.length : 0;
      }

      const baseRowB =iB > 0 ? (4 + totalLength ) + iB * 10  : 4;
      // const baseRowB = 4 + iB * 10;

      // console.log("rowBefore: ", totalLength);
      // console.log("iB: ", iB);

      // console.log("JMLbaserow: ", baseRowB);
  
      // Mengisi data pada setiap sel sesuai dengan baris awal
      worksheet.getCell(`A${baseRowB}`).value = `${toRoman(iB+1)}.`;
      worksheet.getCell(`B${baseRowB}`).value = 'DATA KTP';
      worksheet.getCell(`I${baseRowB}`).value = 'DATA DUKCAPIL';
      worksheet.getCell(`B${baseRowB + 1}`).value = 'Nama Debitur';
      worksheet.getCell(`B${baseRowB + 2}`).value = pinjaman[iB].namaLengkap.substring(0,2) ==='PT' || pinjaman[iB].namaLengkap.substring(0,2) ==='CV' ? 'No.NPWP' : 'No.KTP';
      worksheet.getCell(`B${baseRowB + 3}`).value = pinjaman[iB].namaLengkap.substring(0,2) ==='PT' || pinjaman[iB].namaLengkap.substring(0,2) ==='CV'  ? 'Tempat/Tgl.Pendirian' : 'Tempat/Tgl.Lahir';
      worksheet.getCell(`B${baseRowB + 4}`).value = 'Alamat';
      worksheet.getCell(`C${baseRowB + 1}`).value = pinjaman[iB].namaLengkap.toUpperCase();
      worksheet.getCell(`C${baseRowB + 2}`).value = pinjaman[iB].nomorIdentitas ? pinjaman[iB].nomorIdentitas : '';
      worksheet.getCell(`C${baseRowB + 3}`).value = `${pinjaman[iB].tempatLahir  ? `${pinjaman[iB].tempatLahir} / ` : ' / '} ${pinjaman[iB].tanggalLahir ? `${pinjaman[iB].tanggalLahir.substring(0,2)}-${pinjaman[iB].tanggalLahir.substring(2,4)}-${pinjaman[iB].tanggalLahir.substring(4,8)}`: ''}`;
      worksheet.getCell(`C${baseRowB + 4}`).value = pinjaman[iB].alamat ? pinjaman[iB].alamat : '';
      worksheet.getCell(`I${baseRowB + 1}`).value = 'TELAH DILAKUKAN PENGECEKAN DI DUKCAPIL';
      worksheet.getCell(`I${baseRowB + 3}`).value = 'DENGAN HASIL';
      worksheet.getCell(`I${baseRowB + 4}`).value = pinjaman[iB].ketDukcapil ? pinjaman[iB].ketDukcapil : 'SESUAI';;
  
      // Merge sel pada setiap set data
      worksheet.mergeCells(`B${baseRowB}:H${baseRowB}`);
      worksheet.mergeCells(`I${baseRowB}:K${baseRowB}`);
      worksheet.mergeCells(`C${baseRowB + 1}:H${baseRowB + 1}`);
      worksheet.mergeCells(`C${baseRowB + 2}:H${baseRowB + 2}`);
      worksheet.mergeCells(`C${baseRowB + 3}:H${baseRowB + 3}`);
      worksheet.mergeCells(`C${baseRowB + 4}:H${baseRowB + 4}`);
      worksheet.mergeCells(`I${baseRowB + 1}:K${baseRowB + 2}`);
      worksheet.mergeCells(`I${baseRowB + 3}:K${baseRowB + 3}`);
      worksheet.mergeCells(`I${baseRowB + 4}:K${baseRowB + 4}`);
      
      // Pengaturan lainnya seperti border, alignment, dll.
      worksheet.getCell(`A${baseRowB}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`B${baseRowB}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`B${baseRowB + 1}`).alignment = {vertical: 'middle'};
      worksheet.getCell(`B${baseRowB + 2}`).alignment = {vertical: 'middle'};
      worksheet.getCell(`B${baseRowB + 3}`).alignment = {vertical: 'middle'};
      worksheet.getCell(`B${baseRowB + 4}`).alignment = {vertical: 'middle'};
      worksheet.getCell(`C${baseRowB + 4}`).alignment = {vertical: 'middle', wrapText: true};
      worksheet.getCell(`I${baseRowB}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`I${baseRowB + 1}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`I${baseRowB + 3}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`I${baseRowB + 4}`).alignment = {vertical: 'middle', horizontal: 'center'};

      worksheet.getCell(`C${baseRowB + 1}`).alignment = {vertical: 'middle', wrapText: true};
      worksheet.getCell(`C${baseRowB + 2}`).alignment = {vertical: 'middle', wrapText: true};
      worksheet.getCell(`C${baseRowB + 3}`).alignment = {vertical: 'middle', wrapText: true};
      worksheet.getCell(`I${baseRowB + 1}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`I${baseRowB + 3}`).alignment = {vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`I${baseRowB + 4}`).alignment = {vertical: 'middle', horizontal: 'center', wrapText: true};

      worksheet.getCell(`A${baseRowB}`).font = {bold: true, size:12};
      worksheet.getCell(`B${baseRowB}`).font = {bold: true, size:12};
      worksheet.getCell(`C${baseRowB + 1}`).font = {bold: true, size:12};
      worksheet.getCell(`C${baseRowB + 2}`).font = {bold: true, size:12};
      worksheet.getCell(`C${baseRowB + 3}`).font = {size:12};
      worksheet.getCell(`I${baseRowB}`).font = {bold: true, size:12};
      worksheet.getCell(`I${baseRowB + 4}`).font = {color: { argb: 'FF0000' } };

      worksheet.getRow(baseRowB + 4).height = 30;
      worksheet.getRow(baseRowB).height = 20;
      worksheet.getRow(baseRowB + 1).height = 18;
      worksheet.getRow(baseRowB + 2).height = 18;
      worksheet.getRow(baseRowB + 3).height = 18;

      const bordersBiodata = {
        top: { style: "medium" },
        right: { style: "medium" },
        bottom: { style: "medium" },
        left: { style: "medium" },
      };

      const baseRow2 = iB > 0 ? (8 +  totalLength) + iB * 10  : 8 ;
      for (let row = baseRowB; row <= baseRow2; row++) {
        for (let col = 2; col <= 11; col++) { // Anggap "B" sesuai dengan kolom 2, "K" sesuai dengan kolom 11
          const cell = worksheet.getCell(row, col);
          cell.border = bordersBiodata;
        }
      }
//===============> BIODATA AKHIR <=================

// =================> PINJAMAN <==================

      const baseRowP = baseRowB + 6;
      // console.log("baseRowP: ", baseRowP);

      worksheet.getCell(`B${baseRowP}`).value = 'DATA PINJAMAN';
      worksheet.getCell(`B${baseRowP + 1}`).value = 'NAMA BANK';
      worksheet.getCell(`C${baseRowP + 1}`).value = 'PLAFOND AWAL';
      worksheet.getCell(`D${baseRowP + 1}`).value = 'BAKI DEBET';
      worksheet.getCell(`E${baseRowP + 1}`).value = 'COLL';
      worksheet.getCell(`F${baseRowP + 1}`).value = 'JMN';
      worksheet.getCell(`H${baseRowP + 1}`).value = 'SK BG';
      worksheet.getCell(`I${baseRowP + 1}`).value = 'JW';
      worksheet.getCell(`J${baseRowP + 1}`).value = 'TGL UPDATE SLIK';
      worksheet.getCell(`K${baseRowP + 1}`).value = 'KET';

      worksheet.getCell(`B${baseRowP}`).font = {bold:true, underline:true };

      const bordersHeaderPinjaman = {
        top: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      };

      for (let row = baseRowP+1; row <= baseRowP+1; row++) {
        for (let col = 2; col <= 11; col++) { // Anggap "B" sesuai dengan kolom 2, "K" sesuai dengan kolom 11
          const cell = worksheet.getCell(row, col);
          cell.border = bordersHeaderPinjaman;
        }
      }
      worksheet.getCell(`B${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`C${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`D${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`E${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`F${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`H${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`I${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`J${baseRowP + 1}`).font = {bold:true};
      worksheet.getCell(`K${baseRowP + 1}`).font = {bold:true};

      worksheet.getCell(`B${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`C${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`D${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`E${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`F${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`H${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`I${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };
      worksheet.getCell(`J${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true };
      worksheet.getCell(`K${baseRowP + 1}`).alignment = { vertical: 'middle', horizontal: 'center' };

      worksheet.mergeCells(`F${baseRowP + 1}:G${baseRowP + 1}`);

      
     // ===========> ISI PINJAMAN <================

      if (pinjaman[iB] && pinjaman[iB].pinjaman.length > 0) {
    for (let i = 0; i < pinjaman[iB].pinjaman.length; i++) {
    const baseRowIsi = baseRowP + 2 + i ;
    totalRowAkhirPinjaman = baseRowIsi;

    worksheet.getCell(`B${baseRowIsi}`).value = pinjaman[iB].pinjaman[i].namaBank.toUpperCase();
    worksheet.getCell(`C${baseRowIsi}`).numFmt = '"Rp"#,##0';
    worksheet.getCell(`C${baseRowIsi}`).value = Number(pinjaman[iB].pinjaman[i].plafond);
    worksheet.getCell(`D${baseRowIsi}`).numFmt = '"Rp"#,##0';
    worksheet.getCell(`D${baseRowIsi}`).value = Number(pinjaman[iB].pinjaman[i].bakiDebet);
    worksheet.getCell(`E${baseRowIsi}`).value = `${pinjaman[iB].pinjaman[i].coll.substring(0, 1)}\n${pinjaman[iB].pinjaman[i].jmlHariTunggakan}`;
    worksheet.getCell(`F${baseRowIsi}`).value = pinjaman[iB].pinjaman[i].jaminan.toUpperCase();
    worksheet.getCell(`H${baseRowIsi}`).value = `${pinjaman[iB].pinjaman[i].sukuBunga}%`;
    worksheet.getCell(`I${baseRowIsi}`).value = pinjaman[iB].pinjaman[i].jangkaWaktu;
    worksheet.getCell(`J${baseRowIsi}`).value = `${pinjaman[iB].pinjaman[i].tglUpdateSlik.substring(6,8)}/${pinjaman[iB].pinjaman[i].tglUpdateSlik.substring(4,6)}/${pinjaman[iB].pinjaman[i].tglUpdateSlik.substring(0,4)}`;
    worksheet.getCell(`K${baseRowIsi}`).value = `${pinjaman[iB].pinjaman[i].coll.substring(4).trim().toUpperCase()}, ${pinjaman[iB].pinjaman[i].kondisi.toUpperCase()}`;

    worksheet.getCell(`J${baseRowIsi}`).numFmt = 'dd/mm/yyyy';

    worksheet.getCell(`B${baseRowIsi}`).alignment = { vertical: 'middle', wrapText:true};
    worksheet.getCell(`C${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`D${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`E${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`F${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`H${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`I${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`J${baseRowIsi}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};
    worksheet.getCell(`K${baseRowIsi}`).alignment = { vertical: 'middle', wrapText:true};

    worksheet.getCell(`E${baseRowIsi}`).font = { bold: true};

    worksheet.getRow(`${baseRowIsi}`).height = 50;
  
      worksheet.mergeCells(`F${baseRowIsi}:G${baseRowIsi}`);

      const bordersHeaderPinjaman = {
        top: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      };
      // console.log("baseRow Isi: ", baseRowIsi);

      for (let row = baseRowP+2; row <= baseRowIsi; row++) {
        for (let col = 2; col <= 11; col++) { // Anggap "B" sesuai dengan kolom 2, "K" sesuai dengan kolom 11
          const cell = worksheet.getCell(row, col);
          cell.border = bordersHeaderPinjaman;
        }
      }

      //========> TOTAL PLAFOND AWAL DAN BAKI DEBET <===========
      const jumlahDataPinjamanArray = pinjaman[iB].pinjaman.length;
      const total = baseRowP + 2 + jumlahDataPinjamanArray
      worksheet.getCell(`C${total}`).numFmt = '"Rp"#,##0';
      worksheet.getCell(`C${total}`).value = Number(pinjaman[iB].totalPlafond);
      worksheet.getCell(`D${total}`).numFmt = '"Rp"#,##0';
      worksheet.getCell(`D${total}`).value = Number(pinjaman[iB].totalBakiDebet);

      worksheet.getCell(`C${total}`).alignment = { vertical: 'middle', horizontal: 'center'};
      worksheet.getCell(`D${total}`).alignment = { vertical: 'middle', horizontal: 'center'};

      worksheet.getRow(total).height = 20;

      if (!worksheet.getCell(`E${total}`).isMerged) {
        worksheet.mergeCells(`E${total}:K${total}`);
      }
      const bordersTotalPinjaman = {
        top: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      };

      for (let row = total; row <= total; row++) {
        for (let col = 2; col <= 11; col++) { // Anggap "B" sesuai dengan kolom 2, "K" sesuai dengan kolom 11
          const cell = worksheet.getCell(row, col);
          cell.border = bordersTotalPinjaman;
        }
      }


      // console.log("Total: ", total);
      // console.log("jumlahDataPinjamanArray: ", jumlahDataPinjamanArray);
      // ======== AKHIR TOTAL ======

    }
      

    
      
    }else{
      const baseRowIsiNone = baseRowP + 2 ;
      worksheet.getCell(`B${baseRowIsiNone}`).value = "DATA TIDAK DITEMUKAN";

      worksheet.getCell(`B${baseRowIsiNone}`).alignment = { vertical: 'middle', horizontal: 'center', wrapText:true};

      worksheet.getCell(`B${baseRowIsiNone}`).font = {bold: true, size:12, color: { argb: 'FF0000' } };

      worksheet.mergeCells(`B${baseRowIsiNone}:K${baseRowIsiNone}`);

      worksheet.getRow(baseRowIsiNone).height = 25;

      const bordersHeaderPinjamanNone = {
        top: { style: "thin" },
        right: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
      };

      for (let row = baseRowIsiNone; row <= baseRowIsiNone; row++) {
        for (let col = 2; col <= 11; col++) { // Anggap "B" sesuai dengan kolom 2, "K" sesuai dengan kolom 11
          const cell = worksheet.getCell(row, col);
          cell.border = bordersHeaderPinjamanNone;
        }
      }

    }

    }

    //=============FOOTER================
      const pinjamanTotal = pinjaman[0].pinjaman.length;
      let pinjamanTerakhir = 0
      let getLengthBiodata = pinjaman.length;
      let zeroLengthCount = 0;
      // console.log("LAST: ", lastBiodata);
        for (let iP = 0; iP < pinjaman[lastBiodata].pinjaman.length; iP++) {
          pinjamanTerakhir = iP + 1;
        }
        
        //Bug pinjaman terakhir > 2
        for (let i = 0; i < getLengthBiodata; i++){
          if (pinjaman[i].pinjaman.length === 0) {
            zeroLengthCount++;
          } else {
            zeroLengthCount = 0;
          }
        }
        
      if (pinjamanTerakhir === 0){
         totalRowAkhirPinjaman = totalRowAkhirPinjaman + (10 * zeroLengthCount)
      }

      const richTextValue1 = {
        text: 'SETELAH DILAKUKAN PENGECEKAN SLIK, DEBITUR (*'
      };
      const tidakMemiliki1 = {
        text: 'TIDAK MEMILIKI',
      };
      const tidakMemiliki2 = {
        text: 'TIDAK MEMILIKI',
        font: {
          strike: true
        }
      };
      
      const garing = {
        text: '/',
      };
      const memiliki1 = {
        text: 'MEMILIKI',
        
      };
      const memiliki2 = {
        text: 'MEMILIKI',
        font: {
          strike: true
        }
      };
      const richTextValue2 = {
        text: ') PINJAMAN',
      };
      const richText = pinjamanTotal > 0 ? [richTextValue1, tidakMemiliki2, garing, memiliki1, richTextValue2] : [richTextValue1, tidakMemiliki1, garing, memiliki2, richTextValue2];
      worksheet.getCell(`B${totalRowAkhirPinjaman+3}`).value = "KETERANGAN";
      worksheet.getCell(`B${totalRowAkhirPinjaman+4}`).value = {richText};
      worksheet.getCell(`B${totalRowAkhirPinjaman+5}`).value = "DI BANK UMUM / BPR / SYARIAH ( DATA SLIK TERLAMPIR )";
      worksheet.getCell(`B${totalRowAkhirPinjaman+6}`).value = "HASIL PENGECEKAN DI DUKCAPIL (TERLAMPIR)";
      worksheet.getCell(`C${totalRowAkhirPinjaman+10}`).value = jabatanSpv;
      worksheet.getCell(`C${totalRowAkhirPinjaman+16}`).value = namaSpv;
      worksheet.getCell(`E${totalRowAkhirPinjaman+9}`).value = "MENGETAHUI,";
      worksheet.getCell(`I${totalRowAkhirPinjaman+8}`).value = `${cabang}, ${tanggal}`;
      worksheet.getCell(`I${totalRowAkhirPinjaman+10}`).value = "Petugas SLIK";
      worksheet.getCell(`I${totalRowAkhirPinjaman+16}`).value = namaLengkapUser;
      // console.log("totalRowAkhirPinjaman: ", totalRowAkhirPinjaman)
      // console.log("pinjamanTotal: ", pinjamanTotal);

      worksheet.getCell(`B${totalRowAkhirPinjaman+3}`).font = {bold:true, underline:true };

  }


//-----------------> Penutup Pinjaman

  

// worksheet.getCell('B2').font = { size: 10 };
worksheet.mergeCells("B1:K1");
worksheet.mergeCells("B2:K2");

worksheet.getRow(1).height = 25;

worksheet.getColumn("A").width = 3;
worksheet.getColumn("B").width = 31;
worksheet.getColumn("C").width = 18;
worksheet.getColumn("D").width = 18;
worksheet.getColumn("E").width = 5;
worksheet.getColumn("G").width = 4;
worksheet.getColumn("F").width = 16;
worksheet.getColumn("H").width = 7;
worksheet.getColumn("I").width = 4;
worksheet.getColumn("J").width = 11;
worksheet.getColumn("K").width = 24;
// worksheet.properties.defaultRowFont = { size: 12, name: 'Arial' };
worksheet.headerFooter.oddFooter = "&CPage &P/&N";
worksheet.headerFooter.evenFooter = "&CPage &P/&N";

  // Access the cell
const borderB1 = worksheet.getCell("B1");
const borderB2 = worksheet.getCell("B2");



// Set border properties
borderB2.border = {
  top: { style: "medium" },    // Border atas tipis
  right: { style: "medium" },  // Border kanan tipis
  bottom: { style: "medium" }, // Border bawah tipis
  left: { style: "medium" },   // Border kiri tipis
};

borderB1.font = { size: 14, bold: true}
borderB1.alignment = { vertical: 'middle', horizontal: 'center' };
borderB2.font = { size: 12, bold: true}
borderB2.alignment = { vertical: 'middle', horizontal: 'center' };

  // Atur margin menggunakan ExcelJS
  worksheet.pageSetup.margins = {
    left: 0.4,
    right: 0.0,
    top: 0.1,
    bottom: 0.1,
    header: 0.1,
    footer: 0.1,
  };
  worksheet.pageSetup.paperSize = 9; // 9 adalah kode ukuran kertas A4

  
  worksheet.pageSetup.scale = 70;
  // Generate Excel file
  const buffer = await workbook.xlsx.writeBuffer();

  // Buat blob dari buffer
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

  // Buat URL dari blob
  const url = window.URL.createObjectURL(blob);

  // Buat elemen anchor untuk mendownload file
  const a = document.createElement("a");
  a.href = url;
  a.type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; 
  a.download = `ANALISIS SLIK ${pinjaman[0].namaLengkap.toUpperCase()}.xlsx`;

  // Klik elemen anchor untuk memicu unduhan
  a.click();

  // Hapus URL
  window.URL.revokeObjectURL(url);
};
